import { parseSerial } from '@kronos/domain'
import type { Serial } from '@kronos/domain'

/**
 * Turn whatever a scan produced into a serial.
 *
 * A code can arrive three ways and all three must work:
 *
 *  - the QR payload, `HTTPS://KRONOS.NUPEAK.TOOLS/K7F38`;
 *  - a bare serial, from the USB bench scanner acting as a keyboard (§9.4);
 *  - a serial someone typed off a scuffed label, in whatever case they felt.
 *
 * Anything else — a foreign QR on a shipping box, a supplier's own barcode — is
 * rejected here rather than sent to the server, so the scan loop says "not one
 * of ours" instantly instead of after a round trip.
 */
export function serialFromPayload(raw: string): Serial | null {
  const trimmed = raw.trim()

  // A URL: take the last path segment, whatever host it names. Accepting any
  // host is deliberate — the label host is a config value (§9.1) and labels
  // printed before it changed are still in the field.
  const asUrl = /^https?:\/\/[^/]+\/([^/?#]+)/i.exec(trimmed)
  const candidate = asUrl?.[1] ?? trimmed

  const parsed = parseSerial(candidate)
  return parsed.ok ? parsed.serial : null
}
